import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {compose, setDisplayName, withState} from 'recompose';
import _ from 'underscore';

import {
  Fab,
  List,
} from '@material-ui/core';
import {grey} from '@material-ui/core/colors';
import AddIcon from '@material-ui/icons/Add';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Divider from '@material-ui/core/Divider';

import Confirm from 'common/components/Confirm';

import styles from './AddressList.css';
import AddressItem from './AddressItem.js';


const enhance = compose(
  setDisplayName('AddressList'),
  withState('deleteId', 'setDeleteId', null),
);

const AddressList = enhance(({
  activeId,
  activeChildren,
  addresses,
  deleteId,
  onCreate,
  onDelete,
  onEdit,
  setDeleteId,
}) => {
  if (addresses === null) return null;

  const emptyNode = (
    <div data-id={'no-addresses-message'} className={styles.empty}>
      <p>
        You have not added any favorite addresses yet.
        Use the blue button below to create a new one.
      </p>
      <p>
        Favorited addresses will show on the map as a
        {' '}
        <FavoriteIcon style={{width: 16, height: 16, verticalAlign: 'top'}} />
        {' '}
        for easy access!
      </p>
    </div>
  );

  const listNode = (
    <List data-id={'address-list-container'} style={{paddingBottom: 72}}>
      {/* Show "New Address" editor if there's no active address */}
      {!activeId &&
        activeChildren &&
        <div className={classNames(styles.addressItem, styles.newAddressItem, styles.active)}>
          {activeChildren}
          <div className={styles.divider}><Divider /></div>
        </div>
      }

      {_.map(addresses, (address) => (
        <AddressItem
          address={address}
          dataId={'address-list-row'}
          key={address.addressId}
          onEdit={onEdit}
          onDelete={setDeleteId}
          style={{borderBottom: `1px solid ${grey[300]}`}}
        />
      ))}
    </List>
  );

  return (
    <div>
      {addresses.length > 0 || !!activeChildren ? listNode : emptyNode}

      <div className={classNames(styles.createButton, {[styles.active]: !!activeChildren})}>
        <Fab
          color="primary"
          data-id={'new-address-button'}
          onClick={onCreate}
        >
          <AddIcon />
        </Fab>
      </div>

      <Confirm
        cancelButtonDataId={'cancel-delete-address-button'}
        confirmButtonDataId={'confirm-delete-address-button'}
        confirmButtonText="Yes"
        cancelButtonText="No"
        message="Are you sure you want to delete this address?"
        messageDataId={'delete-address-message'}
        modalDataId={'delete-address-modal-container'}
        onCancel={() => setDeleteId(null)}
        onConfirm={() => {
          onDelete(deleteId);
          setDeleteId(null);
        }}
        open={!!deleteId}
        title="Confirm Delete"
      />
    </div>
  );
});

AddressList.propTypes = {
  activeId: PropTypes.string,
  activeChildren: PropTypes.node,
  addresses: PropTypes.array,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

export default AddressList;



// WEBPACK FOOTER //
// ./src/ondemand/components/AddressList/AddressList.js